import { Link, useParams, Navigate } from 'react-router-dom';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import articles from '@/content/articles';

export default function BlogDetail() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar solid />
        <main className="pt-28 pb-20 px-6 max-w-3xl mx-auto text-center">
          <p className="text-[#64748B] mb-4">文章未找到</p>
          <Link to="/blog" className="text-[#F97316] hover:underline">返回列表</Link>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar solid />

      <main className="pt-28 pb-20 px-6 md:px-10 max-w-5xl mx-auto">
        <button
          onClick={() => window.history.back()}
          className="text-sm text-[#94A3B8] hover:text-[#0F172A] transition-colors mb-8 cursor-pointer flex items-center gap-1"
        >
          <i className="ri-arrow-left-s-line" />
          返回列表
        </button>

        <header className="mb-10">
          <h1
            className="text-2xl md:text-3xl font-bold text-[#0F172A] leading-snug"
            style={{ fontFamily: "'Noto Sans SC', sans-serif" }}
          >
            {article.title}
          </h1>
          <p className="mt-3 text-sm text-[#94A3B8]">{article.date}</p>
        </header>

        <article className="prose-article">
          <Markdown remarkPlugins={[remarkGfm]}>{article.content}</Markdown>
        </article>
      </main>

      <Footer />
    </div>
  );
}
